import { StreemAPI, APIError } from '@streem/api';
import { fetchAllPages } from '@streem/toolbox';
import { BehaviorSubject, distinctUntilChanged, shareReplay, mergeAll, map, scan, } from 'rxjs';
import { logger } from '../../util/logger';
import { streem, WallItem } from 'streem-sdk-protobuf';
import { accumulateAndMapWallEvents, findInGroup } from '../wall/utils';
const TRANSCRIPTIONS_PER_BATCH = 1000; // must be a multiple of 1000
const RETRIES = 1;
export class TranscriptionController {
    constructor(config) {
        this.config = config;
        this.initializedSubject = new BehaviorSubject(false);
        this.errorSubject = new BehaviorSubject(undefined);
        this.transcriptionSegmentsSubject = new BehaviorSubject([]);
        this.initialized = this.initializedSubject.asObservable();
        this.error = this.errorSubject.asObservable();
        this.transcriptionSegments = this.transcriptionSegmentsSubject.asObservable();
        this.refresh = async () => {
            this.initializedSubject.next(false);
            this.errorSubject.next(undefined);
            this.transcriptionSegmentsSubject.next([]);
            await this.loadTranscriptionSegments();
        };
        this.fetchTranscriptionSegments = async (nextPageToken) => {
            const response = await StreemAPI.rooms.listTranscription(this.roomId, TRANSCRIPTIONS_PER_BATCH, nextPageToken);
            return {
                data: response.transcriptionSegments ?? [],
                nextPageToken: response.nextPageToken,
                totalSize: response.totalSize,
            };
        };
        this.roomId = config.context.roomId.toString();
        this._transcriptionFulfilled = config.roomWall.itemsByType.pipe(findInGroup('artifact'), accumulateAndMapWallEvents('artifact'), mergeAll(), map(art => {
            return (art.artifactType === WallItem.ArtifactType.TRANSCRIPTION &&
                art.transcription?.status === streem.api.Artifact.Status.STATUS_FULFILLED);
        }), scan((acc, cur) => acc || cur, false), // if any of these is true, treat it as fulfilled = true
        distinctUntilChanged(), shareReplay(1));
        if (!this.config.context.transcriptionsEnabledYn) {
            this.initializedSubject.next(true);
            logger.debug(`Transcription controller disabled for roomId: ${this.config.context.roomId}`);
            return;
        }
        // need a subscription or the observable will not emit values
        this.transcriptionFulfilledSubscription = this._transcriptionFulfilled.subscribe(fulfilledYn => {
            // this should only happen once
            if (fulfilledYn) {
                logger.debug('transcription marked fulfilled on wall, loading data from API');
                this.refresh();
            }
        });
    }
    disconnect() {
        this.transcriptionFulfilledSubscription?.unsubscribe();
    }
    async loadTranscriptionSegments() {
        try {
            const { data, totalSize } = await fetchAllPages(this.fetchTranscriptionSegments, RETRIES);
            logger.info(`Successfully fetched ${totalSize} transcription segments`);
            this.transcriptionSegmentsSubject.next(data);
            this.initializedSubject.next(true);
        }
        catch (error) {
            this.handleLoadTranscriptionSegmentsError(error);
        }
    }
    handleLoadTranscriptionSegmentsError(error) {
        if (error instanceof APIError && error.status === 404) {
            // this is expected when there are no transcriptions for a room
            logger.info(`No transcriptions for roomId: ${this.roomId}, received 404`);
            this.initializedSubject.next(true);
            return;
        }
        this.initializedSubject.next(false);
        this.errorSubject.next(error);
        logger.error('Failed to initialize transcription controller:', error);
    }
}
//# sourceMappingURL=transcription_controller.js.map